module.exports = __webpack_public_path__ + "static/img/8.9538c7c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/eng/8.png
// module id = 5kBZ
// module chunks = 0